import { Form } from "@minervaproject/fds";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { redirectUser } from "../../helpers";
import { LoginStore } from "../../store/login";
import { OrgSettingsStore, OrgStore, UserStore } from "src/store";
import { omitUndefined } from "src/utils";

const LoginForm = ({ children, defaultValues, onSubmit }) => {
  const { orgIdentifier } = useParams();
  const history = useHistory();

  const { userId, tokenUUID } = useSelector(LoginStore.selectors.select());
  const user = useSelector(UserStore.selectors.selectById(userId));
  const org = useSelector(
    OrgStore.selectors.find(omitUndefined({ short_name: orgIdentifier, id: user?.org_id })),
  );
  const orgSettings = useSelector(OrgSettingsStore.selectors.find({ org_id: org?.id }));

  // Redirect user after successful login
  useEffect(() => {
    // User is only fetched after a successful login.
    // Org also needs to be defined to find out what the org settings are:
    // - on org-specific pages, it should be defined before successful login (orgIdentifier is defined);
    // - on non org-specific pages, it will be defined upon successful login (part of the login API response).
    if (!user || !org) return;

    // We need to wait for the orgSettings to be loaded.
    // However, some orgs do not have orgSettings, in which case it is fine to proceed.
    if (org?.orgsettings_id && !orgSettings) return;

    if (orgSettings?.enable_tos_check) {
      const dateOfLastTermsAccepted = user.terms_of_service_accepted_on;
      const dateOfLastTermsUpdated = orgSettings.tos_updated_on;
      if (
        !dateOfLastTermsAccepted ||
        new Date(dateOfLastTermsAccepted) < new Date(dateOfLastTermsUpdated)
      ) {
        history.push("/accept-terms");
        return;
      }
    }
    redirectUser();
  }, [user, org, orgIdentifier, orgSettings, history]);

  // Redirect user after failed login (multiple orgs)
  useEffect(() => {
    if (tokenUUID && !orgIdentifier) {
      history.push("/select-org");
    }
  }, [tokenUUID, orgIdentifier, history]);

  return (
    <Form onSubmit={onSubmit} defaultValues={defaultValues}>
      {children}
    </Form>
  );
};

export { LoginForm };
